import { Injectable } from '@angular/core';
import { CookieOptions, CookieService as cs } from 'ngx-cookie-service';

/**
 * Wrapping the translateService including fallback rules, branding, etc
 */
@Injectable()
export class CookieService {
  constructor(private cookieService: cs) {}

  // Need to import the angular cookie service
  getCookie(cname: string): string {
    return this.cookieService.get(cname);
  }

  getDesSession(): string {
    return this.cookieService.get('des_session');
  }

  setCookie(name: string, value: string, days?: number): void {
    const cookieOpts: CookieOptions = {
      path: '/',
    };
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      cookieOpts.expires = date;
    }
    this.cookieService.set(name, value, cookieOpts);
  }

  deleteCookie(name: string, path?: string, domain?: string): void {
    if (this.getCookie(name)) {
      const cookieDomain = this.getCookie('domain_cookie');
      this.cookieService.delete(name, path ?? '/', domain ?? cookieDomain ?? '.calibrantenergy.net');
    }
  }
}
